export default "__VITE_ASSET__CKK8pgwa__"